import { TStyleRecord } from 'shared/types/styleCn'

export function getTypedCn(styles: TStyleRecord, prefix: string, name: string | undefined): string | undefined

export function getTypedCn<T extends string, K extends string, S extends Record<`${T}${K}`, string>>(
  styles: S,
  prefix: T,
  name?: K
): string | undefined

export function getTypedCn(styles: any, prefix: any, name: any) {
  if (name !== undefined) {
    const className = `${prefix}${name}`

    return styles[className]
  }
}
